import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';
import { kioskCartFunnelBottomPaddingProperty } from './kiosk-cart-funnel-top-padding';

export const KIOSKCARTFUNNELPAGE_LEGACY_FIELD_ORDER = [
  "background_color",
  "background_image",
  "buttons_background_color",
  "validate_button_background_color",
  "validate_button_text_color",
  "cancel_button_background_color",
  "cancel_button_text_color",
  "bottom_padding",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartFunnelPageDescriptor: _generatedKioskCartFunnelPageDescriptor,
  kioskCartFunnelPageBlocDefinition,
  kioskCartFunnelPageDashboardLayout,
  kioskCartFunnelPageConfig,
  kioskCartFunnelPageResolveConfig,
  kioskCartFunnelPageProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Cart funnel page",
    internal_name: "Kiosk - Cart funnel page",
    url: "cart/funnel",
    defaultParent: [/^Main Layout$/i],
    componentType: 'KioskCartFunnelPageComponent',
    category: 'page',
    description: "Kiosk - Cart funnel page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'header',
        name: "pages.blocks.kiosk-cart-funnel-page.header.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskCartFunnelHeaderBlock", "KioskHeaderBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'content',
        name: "pages.blocks.kiosk-cart-funnel-page.content.label",
        accept: 'explicitOnly',
        allowedTypes: ["TextBlock", "FrameBlock", "ImageFullWidthBlock", "ImageVariableWidthBlock", "ImageAndTextBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'body',
        name: "pages.blocks.kiosk-cart-funnel-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskCartFunnelFormBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'bottom_content',
        name: "pages.blocks.kiosk-cart-funnel-page.bottom-content.label",
        accept: 'explicitOnly',
        allowedTypes: ["TextBlock", "FrameBlock", "ImageFullWidthBlock", "ImageVariableWidthBlock", "ImageAndTextBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-page.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-page.background-image.label",
        help: "pages.blocks.kiosk-cart-funnel-page.background-image.help",
      }
    }),
    buttons_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-100"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-page.buttons-background-color.label",
      }
    }),
    validate_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-page.validate-button-background-color.label",
      }
    }),
    validate_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-page.validate-button-text-color.label",
      }
    }),
    cancel_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-200"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-page.cancel-button-background-color.label",
      }
    }),
    cancel_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-page.cancel-button-text-color.label",
      }
    }),
    bottom_padding: kioskCartFunnelBottomPaddingProperty('kiosk-cart-funnel-page'),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-funnel-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-funnel-page.fieldset.page.label",
            fields: ["background_color", "background_image"],
          },
          {
            legend: "pages.blocks.kiosk-cart-funnel-page.fieldset.footer-bar.label",
            fields: ["buttons_background_color", "bottom_padding"],
          },
          {
            legend: "pages.blocks.kiosk-cart-funnel-page.fieldset.validate-button.label",
            fields: ["validate_button_background_color", "validate_button_text_color"],
          },
          {
            legend: "pages.blocks.kiosk-cart-funnel-page.fieldset.cancel-button.label",
            fields: ["cancel_button_background_color", "cancel_button_text_color"],
          },
          {
            legend: "pages.blocks.kiosk-cart-funnel-page.fieldset.blocks.label",
            fields: ["header", "content", "body", "bottom_content"],
          },
        ],
      },
    ],
  })
);

export function kioskCartFunnelPageDescriptor(): IBlockDescriptor;
export function kioskCartFunnelPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartFunnelPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartFunnelPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartFunnelPageDescriptor, kioskCartFunnelPageProperties, fieldOrder);
}

export {
  kioskCartFunnelPageBlocDefinition,
  kioskCartFunnelPageDashboardLayout,
  kioskCartFunnelPageProperties,
  kioskCartFunnelPageConfig,
  kioskCartFunnelPageResolveConfig,
};

export type KioskCartFunnelPageConfig = typeof kioskCartFunnelPageConfig;
